import { useQuery } from '@apollo/client/react'
import { SearchSelect } from '@src/components/Elements/SearchSelect'
import React, { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import debounce from 'lodash.debounce'
import { StringPaginationType } from '@src/generated/schema'
import { SearchSelectProps } from '@src/components/Elements/SearchSelect/SearchSelect'
import { Account } from '@src/graphql/Account'

export const LastNameSelect: FC<Pick<SearchSelectProps, 'required'>> = (props) => {
  const { t } = useTranslation()
  const { data, loading, fetchMore, refetch } = useQuery<{ lastNames: StringPaginationType }>(Account.lastNames, {
    variables: {
      pageSize: 10,
    },
  })
  const { lastNames: { page, strings, hasNext } = { page: 0, strings: [], hasNext: false } } = data || {}

  const handleSearch = useCallback(
    debounce((filterValue: string) => {
      refetch({ filterValue, pageSize: 10 })
    }, 100),
    [],
  )

  const handlePopupScroll = (e: any) => {
    e.persist()
    const scrollTop = e.target.scrollTop as number
    const offsetHeight = e.target.offsetHeight as number

    if (scrollTop + offsetHeight === e.target.scrollHeight && hasNext) {
      const previousPage: number = page || 0

      fetchMore({
        variables: {
          page: previousPage + 1,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          const newPage = fetchMoreResult?.lastNames?.page || 0
          const oldPage = prev?.lastNames?.page || 0

          if (!fetchMoreResult || newPage <= oldPage) return prev

          const newEdges = fetchMoreResult.lastNames.strings
          const previousEdges = prev?.lastNames?.strings || []

          return newEdges?.length
            ? {
                lastNames: {
                  page: fetchMoreResult.lastNames.page,
                  pages: fetchMoreResult.lastNames.pages,
                  hasNext: fetchMoreResult.lastNames.hasNext,
                  hasPrevious: fetchMoreResult.lastNames.hasPrevious,
                  __typename: prev.lastNames.__typename,
                  strings: [...previousEdges, ...newEdges],
                },
              }
            : prev
        },
      })
    }
  }

  return (
    <SearchSelect
      {...props}
      onSearch={handleSearch}
      onPopupScroll={handlePopupScroll}
      label={t('general.lastName')}
      options={strings?.map((lastName) => ({
        title: lastName,
        value: lastName,
      }))}
      name='lastName'
      loading={loading}
    />
  )
}
